import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'; 
import axios from 'axios'; 
import {api_base_url} from './common/Constants';

import Home from './pages/Home';
import About from './pages/About';
import Quality from './pages/Quality';
import Certificates from './pages/Certificates';
import Products from './pages/Products';
import Machines from './pages/Machines';
import ProjectList from './pages/ProjectList';
import Projects from './pages/Projects';
import ProjectInfo from './pages/ProjectInfo';
import Clients from './pages/Clients';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import ApplyNow from './pages/ApplyNow';
import Blog from './pages/Blog';
import BlogInfo from './pages/BlogInfo';
import CMMessage from './pages/CMMessage';
import React, { useEffect, useState } from 'react';


function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(api_base_url+"get-all-data");
        const data = await res.json();
        
        localStorage.setItem("content", JSON.stringify(data.content));
        localStorage.setItem("settings", JSON.stringify(data.settings));
        localStorage.setItem("banners", JSON.stringify(data.banners));
        localStorage.setItem("categories", JSON.stringify(data.categories));
        localStorage.setItem("products", JSON.stringify(data.products));
        localStorage.setItem("homeproducts", JSON.stringify(data.homeproducts));
        localStorage.setItem("projects", JSON.stringify(data.projects));
        localStorage.setItem("certificates", JSON.stringify(data.certificates));
        localStorage.setItem("machines", JSON.stringify(data.machines));
        localStorage.setItem("project_list", JSON.stringify(data.projectlists)); 
        localStorage.setItem("clients", JSON.stringify(data.clients)); 
        localStorage.setItem("project_types", JSON.stringify(data.projecttypes)); 
        localStorage.setItem("careers", JSON.stringify(data.careers)); 
        localStorage.setItem("blogs", JSON.stringify(data.blogs)); 
        localStorage.setItem("awards", JSON.stringify(data.awards)); 
        localStorage.setItem("metas", JSON.stringify(data.metas)); 
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
  
    fetchSettings();
  }, []);
  
   
  if (loading) return <div class="loader">Loading...</div>;
 
  return (
    <div>  
      <BrowserRouter>
      <Routes>
      <Route  path="/" element={<Home />} > </Route>
      <Route  path="/about-us" element={<About />} > </Route>
      <Route  path="/quality-policy" element={<Quality />} > </Route>
      <Route  path="/certificates" element={<Certificates />} > </Route>
      <Route  path="/chairmans-message" element={<CMMessage />} > </Route>
      <Route  path="/products/:id" element={<Products />} > </Route> 
      <Route  path="/machines" element={<Machines />} > </Route> 
      <Route  path="/projects" element={<Projects />} > </Route>
      <Route  path="/clients" element={<Clients />} > </Route>
      <Route  path="/contact" element={<Contact />} > </Route>
      <Route  path="/project-list/:id" element={<ProjectList />} > </Route> 
      <Route  path="/project-info/:id" element={<ProjectInfo />} > </Route> 
      <Route  path="/careers" element={<Careers />} > </Route> 
      <Route  path="/blog" element={<Blog />} > </Route> 
      <Route  path="/blog-info/:id" element={<BlogInfo />} > </Route> 
      <Route  path="/apply-now/:id" element={<ApplyNow />} > </Route> 
      
      </Routes>
    </BrowserRouter> 
  </div>
     
  );
}

export default App;